const setup = require('./utils/setup');
const createMonitor = require('./factory/monitor');
const monitorUtils = require('./utils');

function serverMonitors(project, allMonitors) {
  setup({ allMonitors, project });
}

module.exports = {
  serverMonitors,
  createMonitor,
  ...monitorUtils
};
